import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import AccordionSection from '../AccordionSection'

import CollectionSourceFunctionsImage from './CollectionSourceFunctionsImage'

const data = {
  anchorId: `source-functions`,
  overline: `Collection`,
  heading: `Source Functions`,
  description: `Often, you’ll want to pull in data from arbitrary web services or internal sources. They’ll have webhooks for triggering new data entries, but no standardized way of getting that data. Here’s how we do it…`,
  accordionSection: SectionWithAccordion.SOURCE_FUNCTIONS,
}

const CollectionSourceFunctions: FC<PropsWithChildren<unknown>> = () => {
  const { anchorId, overline, heading, description, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{description}</CopyTextDescriptionSection>
              <AccordionSection section={accordionSection} />
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <StyledSectionContents>
          <CollectionSourceFunctionsImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

const StyledSectionContents = styled(Section.Contents)`
  margin: auto;
`

export default CollectionSourceFunctions
